angular.module('leanlaw').factory('clientsservice', ['$http', '$q', 'linkService', 'clientsdata', function ($http, $q, linkService, clientsdata) {
  const {
    api
  } = linkService;
  const quickBooksCheck = function (data) {
    const deferred = $q.defer();
    $http.get(`${api.client}/qbcheck`).success(d => {
      data.qbCheck = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for QuickBooks Check");
    });
    return deferred.promise;
  };
  const getClients = function (data, filter) {
    const deferred = $q.defer();
    $http.get(`${api.client}/getclients/${filter}`).success(d => {
      data.clients = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const getnonQbClients = function (data) {
    const deferred = $q.defer();
    $http.get(`${api.client}/getnonqbclients`).success(d => {
      data.clients = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const getCustomers = function (data, page) {
    const deferred = $q.defer();
    $http.get(`${api.client}/getqbcustomers/${page}`).success(d => {
      data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const getCustomersForSearch = function (data, page) {
    const deferred = $q.defer();
    $http.get(`${api.client}/getsearchqbcustomers/${page}/${5}`).success(d => {
      data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const filterCustomers = function (data, page, filter) {
    const deferred = $q.defer();
    $http.get(`${api.client}/filterqbcustomers/${page}/${filter}`).success(d => {
      data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const searchCustomers = function (data, filter, page, pagecount) {
    const deferred = $q.defer();
    $http.get(`${api.client}/searchqbcustomers/${filter}/${page}/${pagecount}`).success(d => {
      data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const bulkImportCustomers = function (data) {
    const deferred = $q.defer();
    $http.get(`${api.client}/bulkimportqb`).success(() => {
      // data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const bulkExportClients = function (data) {
    const deferred = $q.defer();
    $http.get(`${api.client}/bulkexportqb`).success(d => {
      data.messages = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const saveQbToClient = function (data, id) {
    const deferred = $q.defer();
    $http.post(`${api.client}/saveqbclient/${id}`).success(() => {
      // data.qbCustomers = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for clients");
    });
    return deferred.promise;
  };
  const getClient = function (data, id) {
    const deferred = $q.defer();
    $http.get(`${api.client}/get/${id}`).success(d => {
      data.client = d;
      deferred.resolve(data);
    }).error(() => {
      deferred.reject("Error getting bootstrap data for client");
    });
    return deferred.promise;
  };
  const archiveClient = function (data, clientId, archive) {
    const d = $q.defer();
    const url = api.client;
    const u = `${url}/archive/${clientId}/${archive}`;
    $http.post(u).success(() => {
      d.resolve();
    }).error(() => {
      d.reject(`Error in query to api ${url}`);
    });
    return d.promise;
  };
  const associateClient = function (data, id, clientId, associate, displayName) {
    if (displayName === '' || displayName === undefined) displayName = 'NA';
    const d = $q.defer();
    const url = api.client;
    displayName = displayName.replace("&", "And").replace("/", " - ").replace("=", " - ").replace("?", "  ");
    const u = `${url}/associateclient/${id}/${clientId}/${associate}/${displayName}`;
    $http.post(u).success(a => {
      data.message = a.message;
      d.resolve(data);
    }).error(() => {
      d.reject(`Error in query to api ${url}`);
    });
    return d.promise;
  };
  const saveClient = function (data, clientId, name, phone, cell, fax, address, email, archived, clientnumber, clientalias) {
    const d = $q.defer();
    const url = api.client;
    const u = `${url}/save`;
    $http.post(u, {
      clientId,
      name,
      phone,
      cell,
      fax,
      address,
      email,
      archived,
      clientnumber,
      clientalias
    }).success(a => {
      data.message = a.message;
      d.resolve(data);
    }).error(() => {
      d.reject(`Error in query to api ${url}`);
    });
    return d.promise;
  };
  const saveClientToQb = function (data, clientId) {
    const d = $q.defer();
    const url = api.client;
    const u = `${url}/saveclienttoqb/${clientId}`;
    $http.post(u, {
      clientId
    }).success(a => {
      data.messages = a.messages;
      d.resolve(data);
    }).error(() => {
      d.reject(`Error in query to api ${url}`);
    });
    return d.promise;
  };
  const setData = function () {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([quickBooksCheckData(data), getClients(data, 'Active')
    //searchCustomers(data, "")
    ]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const setCustomerData = function (page) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([quickBooksCheckData(data), getCustomers(data, page), getClients(data, 'Active')]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const setCustomerSearchData = function (page) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([quickBooksCheckData(data), getCustomers(data, page)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const filterCustomerData = function (page, filter) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([filterCustomers(data, page, filter)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const searchCustomerData = function (filter, page) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([searchCustomers(data, filter, page, 5)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const bulkImportCustomerData = function () {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([bulkImportCustomers(data)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const bulkExportClientData = function () {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([bulkExportClients(data)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const saveQbToClientData = function (id) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([saveQbToClient(data, id)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  var quickBooksCheckData = function () {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([quickBooksCheck(data)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const associateClientData = function (id, displayName, clientId, associate) {
    const deferred = $q.defer();
    const data = clientsdata;
    $q.all([associateClient(data, id, clientId, associate, displayName)]).then(() => {
      deferred.resolve(data);
    });
    return deferred.promise;
  };
  const getDataModel = function () {
    return clientsdata;
  };
  return {
    getDataModel,
    setData,
    setCustomerData,
    getClient,
    getClients,
    saveClient,
    archiveClient,
    getCustomers,
    filterCustomerData,
    bulkImportCustomerData,
    saveQbToClientData,
    quickBooksCheckData,
    associateClientData,
    getnonQbClients,
    saveClientToQb,
    bulkExportClients,
    searchCustomerData,
    getCustomersForSearch
  };
}]);